import { Reveal } from "./Reveal";
import { Wind, Waves, Music, BookOpen, MoonStar, Sparkles } from "lucide-react";

const features = [
  { icon: Wind, label: "Exercices de respiration guidés" },
  { icon: Waves, label: "Relaxation musculaire progressive" },
  { icon: Sparkles, label: "Visualisations apaisantes" },
  { icon: Music, label: "7 relaxations audio guidées" },
  { icon: MoonStar, label: "3 ambiances sonores longues" },
  { icon: BookOpen, label: "Journal du sommeil & tracker" },
];

export const Solution = () => {
  return (
    <section
      data-testid="solution-section"
      className="relative mx-auto max-w-6xl px-6 py-24 md:py-32 lg:px-10"
    >
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <p className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-[#c9a84c]">
              La méthode
            </p>
            <h2 className="text-4xl font-light leading-tight tracking-tight sm:text-5xl">
              NUIT CALME,
              <br />
              <span className="text-gold-gradient italic">c’est quoi&nbsp;?</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-md text-lg leading-relaxed text-white/60">
              Un programme progressif de 21 nuits, structuré en trois semaines
              douces&nbsp;: <span className="text-white/90">Déconnecter</span>,{" "}
              <span className="text-white/90">Relâcher</span>, puis installer{" "}
              <span className="text-white/90">ta routine</span>. Quelques minutes
              chaque soir, à ton rythme.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-px overflow-hidden rounded-2xl border border-white/5 bg-white/5 sm:grid-cols-2">
          {features.map((f, i) => (
            <Reveal
              key={f.label}
              delay={i * 0.06}
              className="group flex flex-col gap-4 bg-[#0a0e1a] p-6 transition-colors duration-500 hover:bg-[#140b26]"
            >
              <f.icon
                className="h-6 w-6 text-[#c9a84c] transition-transform duration-500 group-hover:scale-110"
                strokeWidth={1.4}
              />
              <span className="text-sm leading-snug text-white/75">{f.label}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
